/*
 * The end screen's "run" stats, from the routes this visitor has seen
 * (useVisited): steps, products and sections explored, and a 1–3 star rating
 * on the share of steps seen. /next-step itself always counts (Screen marks it).
 */
import { PRODUCTS, SECTIONS, STEPS, getStepByRoute } from '../../demo/steps';

// Share of the walkthrough's steps needed for 3 and 2 stars; anything less is 1.
const THREE_STARS = 0.8;
const TWO_STARS = 0.4;

export function exploreScore(visited) {
  const seen = new Set();
  visited.forEach((route) => {
    const step = getStepByRoute(route);
    if (step) seen.add(step.route);
  });
  const pages = seen.size;
  const products = PRODUCTS.filter((p) => seen.has(p.route)).length;
  const sections = SECTIONS.filter((sec) => STEPS.some((s) => s.section === sec.key && seen.has(s.route))).length;
  const share = pages / STEPS.length;
  const stars = share >= THREE_STARS ? 3 : share >= TWO_STARS ? 2 : 1;
  return {
    pages,
    totalPages: STEPS.length,
    products,
    totalProducts: PRODUCTS.length,
    sections,
    totalSections: SECTIONS.length,
    stars,
  };
}
